export default {
  primary: '#3c7090',
  secondary: '#348ECA',
  accent: '#82B1FF',
  error: '#F0656B',
  info: '#2196F3',
  success: '#00ABA4',
  warning: '#FF9800',
  contrast: '#1E1E1E',
  footer: '#1E1E1E',
};
